// Copies a discount code to the clipboard and briefly confirms with translated text.
class SCopyCode extends HTMLElement {
  #controller = null;
  #timer = 0;

  connectedCallback() {
    this.#controller = new AbortController();
    this.addEventListener('command', (event) => this.#onCommand(event), { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    clearTimeout(this.#timer);
  }

  async #onCommand(event) {
    if (event.command !== '--copy') return;
    const button = event.source;
    const label = button.querySelector('[data-copy-label]');
    const status = this.querySelector('[data-copy-status]');
    try {
      await navigator.clipboard.writeText(this.dataset.code || '');
    } catch {
      return;
    }
    if (status) {
      status.textContent = '';
      requestAnimationFrame(() => { status.textContent = this.dataset.copiedMessage || ''; });
    }
    if (label) {
      const original = label.dataset.original || label.textContent;
      label.dataset.original = original;
      label.textContent = this.dataset.copiedMessage || original;
      clearTimeout(this.#timer);
      this.#timer = setTimeout(() => { label.textContent = original; }, 2000);
    }
  }
}

if (!customElements.get('s-copy-code')) customElements.define('s-copy-code', SCopyCode);
